﻿<script>
  import { getContext } from "svelte";
  import { navigate } from "svelte-routing";
  import { fade, slide } from "svelte/transition";
  import { Tabs, Tab, TabList, TabPanel } from "svelte-tabs";
  import { languageTextsStore } from "../store/languageTexts.js";

  const { close } = getContext("modal");
  const { snackbar } = getContext("app");
  export let langTextFilterCountryVersion = -1;
  export let id;

  $: languageText =
    $languageTextsStore &&
    $languageTextsStore.allKeys &&
    $languageTextsStore.allKeys.find((l) => l.langKey == id);

  async function save() {
    if (languageText.langKey == "") {
      return;
    }
    await languageTextsStore.saveMultiple(languageText, langTextFilterCountryVersion);
    snackbar("success", "item saved");
    close();
  }

  function init(element) {
    element.focus();
  }

  function SetText(lang, e) {
    var langItem = languageText.langTexts.find((lt) => lt.langName == lang);
    if (!langItem) {
      langItem = { langKey: languageText.langKey, langName: lang };
      languageText.langTexts.push(langItem);
    }
    langItem.langValue = e.srcElement.value;
    languageText = languageText;
  }

  function GetText(lang) {
    var item =
      languageText &&
      languageText.langTexts &&
      languageText.langTexts.find((lt) => lt.langName == lang);

    if (!item) return "";

    return item.langValue;
  }
</script>

{#if languageText}
  <h2 class="text-primary" id="exampleModalLabel">
    Language item: {languageText.langKey}
  </h2>
  {#if $languageTextsStore && $languageTextsStore.allLangs}
    <Tabs>
      <TabList>
        {#each $languageTextsStore.allLangs.filter((l) => l != "null" && l != null) as lang}
          <Tab>{lang}</Tab>
        {/each}
      </TabList>

      {#each $languageTextsStore.allLangs.filter((l) => l != "null" && l != null) as lang}
        <TabPanel>
          <textarea
            rows="10"
            class="form-control"
            placeholder="Text"
            use:init
            on:change={(e) => SetText(lang, e)}
            value={GetText(lang)}
            required=""
          />
        </TabPanel>
      {/each}
    </Tabs>
  {/if}
{/if}
<button type="button" class="btn btn-primary" on:click={close}> Close </button>
<button type="button" class="btn btn-primary" on:click={save}> Save </button>
<br />
